import { Navigate, useLocation } from "react-router-dom";
import {
  PROCESS_QUERY_PARAM,
  openProcessHref,
} from "@/shared/lib/processNavigation";

/**
 * Guarda global: se a rota atual NÃO for a home e a URL trouxer
 * `?process=<id>`, redireciona para `/?process=<id>` para que o `Index`
 * abra o detalhe do processo. Mantém os demais query params intactos
 * (mas eles ficam órfãos na home — o param `process` é o único consumido).
 *
 * Isso garante consistência: notificações, deep links, atalhos colados
 * em qualquer rota acabam abrindo o detalhe do processo no mesmo lugar.
 */
const PRESERVE_PARAM_ROUTES = ["/auth", "/reset-password"];

export const ProcessRouteRedirector = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const pid = params.get(PROCESS_QUERY_PARAM);

  // Em rotas de autenticação preservamos o param para que ele seja
  // restaurado após o login (evita loop com o ProtectedRoute).
  const shouldPreserve = PRESERVE_PARAM_ROUTES.includes(location.pathname);

  if (pid && location.pathname !== "/" && !shouldPreserve) {
    return <Navigate to={openProcessHref(pid)} replace />;
  }

  return <>{children}</>;
};
